import React, { useRef } from "react";
import PropTypes from "prop-types";
import "./GridPaging.css";

const GridPaging = ({
  currentPage,
  totalPages,
  handlePageChange,
  pageSize,
  totalRecords,
}) => {
  GridPaging.propTypes = {
    currentPage: PropTypes.number,
    totalPages: PropTypes.number,
    handlePageChange: PropTypes.func,
  };
  const announcement = useRef(null);

  const pageCountToShow = 5; //No of page numbers to show in pagination

  const getPageNumbers = () => {
    const pageNumbers = [];
    if (totalPages <= pageCountToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const midPage = Math.floor(pageCountToShow / 2);
      const startPage = Math.max(1, currentPage - midPage);
      const endPage = Math.min(totalPages, startPage + pageCountToShow - 1);
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
    }
    return pageNumbers;
  };

  const recordCount = () => {
    let firstNumber = pageSize * (currentPage - 1) + 1;
    let secondNumber = Math.min(pageSize * currentPage, totalRecords);
    let total = totalRecords;
    let recordCountText = "";
    if (total === 1) {
      recordCountText = "Record 1 of 1";
    } else if (firstNumber === secondNumber) {
      recordCountText = "Record " + secondNumber + " of " + total;
    } else {
      recordCountText =
        "Records " + firstNumber + "-" + secondNumber + " of " + total;
    }
    announcement.current = "Displaying " + recordCountText;
    return recordCountText;
  };

  return (
    <div className="pagination-container">
      <div className="visually-hidden" aria-live="polite">
        {announcement.current}
      </div>
      <div className="record-count">{recordCount()}</div>
      <div className="pagination-button-container">
        <button
          title="Previous Page"
          aria-disabled={currentPage === 1}
          readOnly={currentPage === 1}
          className={
            "pagination-button prev-button " +
            (currentPage === 1 && "disabled-button")
          }
          onClick={() => {
            if (currentPage !== 1) {
              handlePageChange(currentPage - 1);
            }
          }}
        >
          <i className="fa fa-caret-left"></i>
        </button>
        {getPageNumbers().map((pageNumber) => (
          <button
            key={pageNumber}
            className={pageNumber === currentPage ? "selected-page" : "page"}
            onClick={() => handlePageChange(pageNumber)}
          >
            {pageNumber}
          </button>
        ))}
        <button
          title="Next Page"
          aria-disabled={currentPage === totalPages}
          readOnly={currentPage === totalPages}
          className={
            "pagination-button next-button " +
            (currentPage === totalPages && "disabled-button")
          }
          onClick={() => {
            if (currentPage !== totalPages) {
              handlePageChange(currentPage + 1);
            }
          }}
        >
          <i className="fa fa-caret-right"></i>
        </button>
      </div>
    </div>
  );
};
export default GridPaging;
